import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {EstimateQuestion, EstimateQuestionType, Order, Product, StandardName} from "../../../store/state/order.state";
import {ChangeSet} from "../history/order-history.model";

@Component({
    selector: 'estimate-questions-details',
    templateUrl: './estimate-questions-details.template.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EstimateQuestionsDetailsComponent {

	readonly LONG_OPTION_SINGLE_CHOICE: EstimateQuestionType = EstimateQuestionType.LONG_OPTION_SINGLE_CHOICE;

	@Input() order: Order;
	@Input() product: Product;
	@Input() changeSet: ChangeSet;
	@Input() translateClientsData: boolean;
	@Input() useOriginalTranslations: boolean;

	estimateQuestions(): EstimateQuestion[] {
		if (this.product.standard.name === StandardName.ISO_27701) {
			const iso27001 = this.order.products.find(p => p.standard.name === StandardName.ISO_27001);
			return this.product.estimateQuestions.filter(iso27701Question => !iso27001.estimateQuestions.find(eq => eq.questionId == iso27701Question.questionId));
		}

		return this.product.estimateQuestions;
	}

}
